import $ from 'jquery';
import manager from 'app/module46/component-manager.js';

manager.register('my-representatives', (component, elements, attributes, properties) => {

	const {
		filter,
		loader,
		container
	} = elements;

	const {
		url
	} = attributes;

	let xhr = null;

	if (filter) {
		$(filter).dropdown({

			onChange: (value, text, selected) => {

				if (url) {

					if (loader) {
						$(loader).stop().show();
					}

					if (container) {
						container.innerHTML = '';
					}

					if (xhr) {
						xhr.abort();
					}

					xhr = manager.get(url + '?event=' + value, (response) => {

						if (container) {
							container.innerHTML = response;
							$(container).stop().fadeIn();
						}

						manager.execute(container);

						if (loader) {
							$(loader).stop().hide();
						}
					});
				}
			}
		});
	}
});
